<template>

    <div class="grid">
        <loading :active="isLoadingModel" :can-cancel="true" color="#803BB9" :is-full-page="fullPage"></loading>
        <div class="col-12">
            <div class="card">
                <Toast />
                <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems">
                    <template #item="{ item, props }">
                        <router-link v-if="item.to" v-slot="{ href, navigate }" :to="item.to" custom>
                            <a :href="href" @click="navigate">
                                <span :class="[item.icon, 'text-color']" />
                                <span class="text-primary font-semibold">{{ item.label }}</span>
                            </a>
                        </router-link>
                    </template>
                </Breadcrumb>
            </div>

            <div class="card">
                <div class="p-fluid formgrid grid" style="margin-top: 1% ; margin-bottom: 1%;">
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <InputText type="text" format="number" v-model="search_title">
                            </InputText>
                            <label for="m_no">Title</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <InputText type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                maxlength="10" v-model="search_application_mobile"></InputText>
                            <label for="name">Mobile</label>
                        </span>
                    </div>
                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <Dropdown id="status" v-model="search_status" :options="status_dropdown"
                                :value="status_dropdown" optionLabel="name" filter></Dropdown>
                            <label for="status">Status</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <Dropdown id="User" filter v-model="state_dropdownItem" :options="state_dropdownItems"
                                optionLabel="name" :value="state_dropdownItems.value" @change="getDistrictData"
                                display="chip">
                            </Dropdown>
                            <label for="complaint_status">State</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <Dropdown id="User" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                                optionLabel="name" @change="getMuncipalCorporationData" display="chip">
                            </Dropdown>
                            <label for="complaint_status">District</label>
                        </span>
                    </div>

                    <div class="field col-12 md:col-2">
                        <span class="p-float-label">
                            <Dropdown id="User" filter v-model="mcorporation_dropdownItem"
                                :options="mcorporation_dropdownItems" optionLabel="name" display="chip">
                            </Dropdown>
                            <label for="complaint_status">Muncipal Corporation</label>
                        </span>
                    </div>


                    <div class="field col-12 md:col-2">
                        <Button icon="pi pi-search" @click="search(1)" v-tooltip.bottom="'Search'" /> &nbsp;
                        <Button icon="pi pi-refresh" @click="search(2)" v-tooltip.bottom="'Reset'" class="mr-2" />
                    </div>
                </div>
                <DataTable :loading="loading" ref="dt" size="small" :lazy="true" :totalRecords="totalRecords"
                    :paginator="true" :value="products" v-model:selection="selectedProducts" :dataKey="columns[0]"
                    :rows="limit" :filters="filters" @page="onPage($event)"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25, totalRecords]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" responsiveLayout="scroll"
                    showGridlines :rowHover="true"><template #empty>
                        <b style="text-align: center">No records found.</b>
                    </template>
                    <template #header>
                        <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                            <h5 class="m-0"><b>Users List</b></h5>
                            <div>
                                <Button icon="pi pi-plus" @click="openNew()" v-tooltip.bottom="'Add'" class="mr-2" />
                                <Button icon="pi pi-download" @click="exportCSV($event)" v-tooltip.bottom="'Download'"
                                    class="mr-2 p-button-help" />
                                <br>
                                <p>Total : {{ totalRecords }}</p>
                            </div>
                        </div>
                    </template>
                    <Column header="Sr. No." style="min-width: 2rem; text-align: center">
                        <template #body="{ index }">
                            <span v-if="page_no == 1">{{ +index + +1 }}</span>
                            <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
                        </template>
                    </Column>
                    <Column header="Status" style="min-width: 3rem">
                        <template #body="{ data }">
                            <span v-if="data.STATUS == 'Active' || data.STATUS == 'active'">
                                <badge :value=data.STATUS severity="success"></badge>
                            </span>
                            <span v-else-if="data.STATUS == 'InActive' || data.STATUS == 'Inactive'">
                                <badge :value=data.STATUS severity="warning"></badge>
                            </span>
                            <span v-else-if="data.STATUS == 'Deleted' || data.STATUS == 'deleted'">
                                <badge :value=data.STATUS severity="danger"></badge>
                            </span>
                            <span v-else>-</span>
                        </template>
                    </Column>

                    <Column header="Name" :field="columns[1]">
                        <template #body="{ data }">
                            {{ data.NAME }}
                        </template>
                    </Column>

                    <Column header="Email" :field="columns[13]" style="text-align:right;">
                        <template #body="{ data }">
                            {{ data.EMAIL }}
                        </template>
                    </Column>
                    <Column header="Address" :field="columns[4]" style="min-width: 7rem">
                        <template #body="{ data }">
                            {{ data.ADDRESS }}
                        </template>
                    </Column>
                    <Column header="Pincode" :field="columns[12]" style="text-align:right;">
                        <template #body="{ data }">
                            {{ data.PINCODE }}
                        </template>
                    </Column>
                    <Column header="Mobile" :field="columns[9]" style="text-align:right;">
                        <template #body="{ data }">
                            {{ data.MOBILE }}
                        </template>
                    </Column>
                    <Column header="State" :field="columns[4]">
                        <template #body="{ data }">
                            {{ data.State_name }}
                        </template>
                    </Column>
                    <Column header="District" :field="columns[6]">
                        <template #body="{ data }">
                            {{ data.district_name }}
                        </template>
                    </Column>
                    <Column header="Muncipal Corporation" :field="columns[7]">
                        <template #body="{ data }">
                            {{ data.MunicipalCorporation }}
                        </template>
                    </Column>

                    <Column header="Action" headerStyle="min-width:13rem;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" title="Edit Client" v-tooltip.bottom="'Edit'"
                                class="p-button-rounded p-button-warning mr-2" @click="editProduct(slotProps.data)" />
                            <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'"
                                class="p-button-rounded p-button-danger mr-2"
                                @click="confirmDeleteProduct(slotProps.data)" />
                            <!-- <Button icon="pi pi-eye" class="p-button-rounded p-button-success mr-2"
                  @click="viewProduct(slotProps.data)" /> -->
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Add Notification Dialog Box start -->
    <Sidebar v-model:visible="productDialog1" :baseZIndex="1000" position="full" @hide="onHide()">
        <div class="col-12">
            <div class="card">
                <h5 v-if="product._id">Update Song Form</h5>
                <h5 v-else>Add Song Form</h5>
                <hr />
                <div class="p-fluid formgrid grid">
                    <div class="p-field col-12 md:col-4">
                        <label for="name">Song Name</label>
                        <InputText id="name" class="label-gap" v-model="product.song_name" />
                    </div>

                    <div class="p-field col-12 md:col-4">
                        <label for="singer">Singer</label>
                        <InputText id="singer" class="label-gap" v-model="product.singer" />
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="music_composer">Music Composer</label>
                        <InputText id="music_composer" class="label-gap" v-model="product.composer" />
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="lyrics_writer" class="label-gap">Lyrics Writer</label>
                        <InputText id="lyrics_writer" v-model="product.lyrics_writer" />
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="duration" class="label-gap">Duration(min)</label>
                        <InputText id="duration" v-model="product.duration" disabled />
                    </div>
                    <div class="p-field col-12 md:col-4">
                        <label for="date">Date</label>
                        <Calendar id="date" class="label-gap" v-model="product.date" showIcon />
                    </div>


                </div>
                <hr />
            </div>
        </div>

        <div class="col-12 md:col-6">
            <Button style="background-color: white; border: 1px solid #349CE4; color: #349CE4;"
                v-if="product.notification_id" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                @click="adduser" />
            <Button style="background-color: white; border: 1px solid #349CE4; color: #349CE4;" v-else label="ADD"
                icon="pi pi-check" class="p-button-success mr-1 mb-1" @click="adduser" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button style="background-color: #349CE4;" label="Cancel" icon="pi pi-times"
                class="p-button-primary mr-1 mb-1" @click="onHide()" />
        </div>
    </Sidebar>
    <!--  -->
    <Sidebar v-model:visible="productDialog" :baseZIndex="1000" position="full" @hide="onHide()">
        <div class="col-12">
            <div class="card">
                <h5>User Form</h5>
                <hr />
                <div class="p-fluid formgrid grid">

                    <div class="field col-12 md:col-3">
                        <label for="NAME">Name</label>
                        <InputText id="NAME" type="text" v-model.trim="product.NAME" required="true" autofocus
                            :class="{ 'p-invalid': submitted && !product.NAME }" />
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="mobile">Mobile No</label>
                        <InputText id="mobile" type="number" v-model.trim="product.MOBILE" required="true" autofocus
                            :class="{
                                'p-invalid': submitted && !product.MOBILE,
                            }" />
                    </div>

                    <div class="field col-12 md:col-3" v-if="!product.ID">
                        <label for="email">Email</label>
                        <InputText id="email" type="text" v-model.trim="product.EMAIL" required="true" autofocus
                            :class="{ 'p-invalid': submitted && !product.EMAIL }" />
                    </div>

                    <div class="field col-12 md:col-3" v-if="!product.ID">
                        <label for="password">Password</label>
                        <InputText id="password" :type="passwordFieldType" v-model="product.PASSWORD"
                            :class="{ 'p-invalid': submitted && !product.PASSWORD }" />
                        <!-- <button type="button" @click="togglePasswordVisibility" class="toggle-password-button"> Show
                            <i icon="pi pi-eye"></i>
                        </button> -->
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="status">Status</label>
                        <Dropdown id="status" v-model="status_selected" :options="status_dropdown"
                            :value="status_dropdown" optionLabel="name" filter>
                        </Dropdown>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="roll">User Type</label>
                        <Dropdown id="roll" filter v-model="rollID_selected" :options="roll_ID_dropdownItems"
                            optionLabel="name" :value="roll_ID_dropdownItems.value" @change="getDistrictData"
                            display="chip">
                        </Dropdown>
                    </div>

                    <div class="field col-12">
                        <label for="address">Address</label>
                        <Textarea id="address" type="text" v-model.trim="product.ADDRESS" required="true" autofocus
                            :class="{ 'p-invalid': submitted && !product.ADDRESS }" />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label for="state">State</label>
                        <Dropdown id="state" filter v-model="state_selected" :options="state_dropdownItems"
                            optionLabel="name" :value="state_dropdownItems.value" @change="getDistrictData"
                            display="chip">
                        </Dropdown>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="dist">District</label>
                        <Dropdown id="dist" filter v-model="district_selected" :options="district_dropdownItems"
                            optionLabel="name" @change="getMuncipalCorporationData" display="chip">
                        </Dropdown>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="corporaion">Muncipal Corporation</label>
                        <Dropdown id="corporaion" filter v-model="mcorporation_selected" :options="mcorporation_dropdownItems"
                            optionLabel="name" display="chip">
                        </Dropdown>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label for="pincode">Pincode</label>
                        <InputText id="pincode" type="number" v-model.trim="product.PINCODE" required="true" autofocus
                            :class="{ 'p-invalid': submitted && !product.PINCODE }" />
                    </div>

                    <div class="field col-12 md:col-3" style="margin-top: 1%">
                        <Button style="background-color: #349CE4; border: 1px solid #349CE4;" label="Upload Thumbnail"
                            @click="toggleShow" icon="pi pi-check" class="p-button" />
                        <my-upload field="img" @crop-success="cropSuccess" langType="en" v-model="show_image" :url="url"
                            :params="params" :headers="headers" img-format="png" :noCircle="true" :noRotate="false">
                        </my-upload>
                    </div>

                    <div class="field col-4 md:col-4" style="padding-top: 10px;">
                        <img :src="imgDataUrl" v-if="imgDataUrl" style="max-width: 50%; 
                                max-height: 200px; 
                                margin-top: 10px; 
                                border: 2px solid #D3D3D3;">
                    </div>

                </div>
            </div>
        </div>

        <div class="col-12 md:col-6">
            <Button v-if="product.ID" label="UPDATE" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                @click="adduser" />
            <Button v-else label="ADD" icon="pi pi-check" class="p-button-success mr-1 mb-1"
                @click="adduser" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Button label="Cancel" icon="pi pi-times" class="p-button-primary mr-1 mb-1" @click="onHide()" />
        </div>
    </Sidebar>
    <!-- Add Notification Dialog Box end -->

    <!--  -->
    <Dialog v-model:visible="deleteProductDialog" :style="{ width: '450px' }" header="Confirm" :modal="true">
        <div class="flex align-items-center justify-content-center">
            <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
            <span v-if="product">Are you sure you want to delete <b>{{ product.name }}</b>?</span>
        </div>
        <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deletegroup" />
        </template>
    </Dialog>
    <!--  -->

</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
import BreadcrumbService from "../service/BreadcrumbService";
import { GoogleMap, Marker, MarkerCluster, InfoWindow, GMapMarker, Polyline } from "vue3-google-map";
import myUpload from "vue-image-crop-upload";

export default {
    data() {
        return {
            // width: 500,
            // height: 500,
            headers: {
                smail: "*_~",
            },
            params: {
                token: "123456798",
                name: "avatar",
            },
            Thumbnail_data: {
                filePath: "",
                contentType: "",
            },
            selecttype: "",
            url: "",
            imgDataUrl: "",
            show_image: false,
            passwordFieldType: 'text',
            roll_ID_dropdownItems: [],
            rollID_selected: { name: "", value: "" },
            state_dropdownItems: [],
            state_dropdownItem: null,
            district_dropdownItems: [],
            district_dropdownItem: null,
            mcorporation_dropdownItems: [],
            mcorporation_dropdownItem: null,
            status_selected: { name: "", value: "" },
            state_selected: { name: "", value: "" },
            district_selected: { name: "", value: "" },
            mcorporation_selected: { name: "", value: "" },
            center: { lat: 19.0626704, lng: 73.005094 },
            hoarding_dropdownItems: [],
            hoarding_dropdownItem: { name: "", value: "" },
            user_dropdownItems: [],
            user_dropdownItem: { name: "", value: "" },
            search_title: "",
            search_status: "",
            search_hoarding: "",
            search_user: "",
            // notification_status: "",
            notification_status: { name: "", value: "" },
            status_dropdown: [
                { name: "Active", value: "Active" },
                { name: "InActive", value: "InActive" },
                { name: "Deleted", value: "Deleted" },
            ],
            search_application_mobile: "",
            breadcrumbHome: {},
            breadcrumbItems: [],
            BreadcrumbService: null,

            page_no: 1,
            isLoading: false,
            isLoadingModel: false,
            loading: false,
            fullPage: true,
            file_attachment: "",
            products: null,
            productDialog: false,
            deleteProductDialog: false,
            lazyParams: {},
            product: {},
            selectedProducts: null,
            filters: {},
            offset: 1,
            limit: 10,
            columns: [],
            pageno: 1,
            submitted: false,
            totalRecords: 0,
            id: "",
        };
    },
    productService: null,
    async created() {
        this.productService = new ProductService();
        this.initFilters();
        this.BreadcrumbService = new BreadcrumbService();
        let Breadcrum_data = this.BreadcrumbService.getBreadcrum("User", "/usermaster")
        this.breadcrumbHome = Breadcrum_data.home;
        this.breadcrumbItems = Breadcrum_data.items;
        this.get_hoarding_dropdown();
        this.get_user_dropdown();
        this.getStateData();
        this.getDistrictData();
        this.getMuncipalCorporationData();
        this.get_rollID_dropdown();
    },
    async mounted() {
        // this.productService.getProducts().then(data => this.products = data);
        this.id = this.$route.params.id;
        this.lazyParams = {
            first: 0,
            rows: this.limit,
            sortField: null,
            sortOrder: null,
            filters: this.filters,
        };
        if (this.totalRecords == 0) {
            await this.get_count();
        }
        await this.get_list();
        //alert(this.id);
    },
    watch: {
        async $route() {
            this.products = [];
            this.columns = [];
            this.totalRecords = 0;
            this.id = this.$route.params.id;
            if (this.id) {
                // await this.get_count();
                // this.get_list();
            }
        },
    },
    methods: {
        async cropSuccess(imgDataUrl) {
            this.imgDataUrl = imgDataUrl;
            var substrings = imgDataUrl.split(";");
            var contentType = substrings[0].split(":");
            var type = imgDataUrl.split(";")[0].split("/")[1];
            this.handleFileUpload_thumb_with_cropper(
                imgDataUrl,
                type,
                contentType[0]
            );
        },
        toggleShow() {
            this.show_image = !this.show_image;
        },
        async handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType) {

            var prfeix = await this.generateString();
            var filename = "Thumbnail_" + prfeix + "." + type;

            //var filename = this.product.title + "." + type;
            var subimgDataUrl = imgDataUrl.split(",");
            var file = await this.handleFileChange(
                subimgDataUrl[1],
                contentType,
                filename
            );
            this.Thumbnail_data = {
                filePath: "",
                contentType: "",
            };
            this.Thumbnail_data = {
                filePath:
                    "Profile/" +
                    this.selecttype.name +
                    "/" +
                    this.product.NAME +
                    "/" +
                    filename,
                contentType: contentType,
            };
            this.isLoadingModel = true;
            var promise = apis.upload_to_AWS(this.Thumbnail_data);
            promise.then((response) => {
                axios
                    .put(response.data.data, file, {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                            "Content-Type": contentType,
                        },
                    })
                    .then((response) => {
                        this.isLoadingModel = false;
                        this.$toast.add({
                            severity: "success",
                            summary: "success",
                            detail: "Upload Successfully",
                            life: 3000,
                        });
                        return false;
                    });
            });
        },
        async generateString() {
            const currentDateTime = new Date();
            const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');
            const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');
            const resultString = `${formattedDate}_${formattedTime}`;

            return resultString;
        },
        async handleFileChange(base64, content_Type, filename) {
            const base64String = base64;
            const contentType = content_Type;
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: contentType });
            const fileName = filename;
            var file = new File([blob], fileName, { type: contentType });
            return file;
        },
        async replaceSpacesWithUnderscores(inputString) {
            var temp = inputString.replace(/ /g, "_");
            var match = temp.match(/^(.*)\.([^.]+)$/);
            return {
                beforeDot: match[1], // Part before the last dot
                removedPart: "." + match[2], // Removed part (file extension with dot)
            };
        },
        async reset_upload() {

            this.imgDataUrl = "";
            this.Thumbnail_data = {
                filePath: "",
                contentType: "",
            };
        },
        passwordButtonText() {
            return this.passwordFieldType == 'password' ? 'show' : 'hide';
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        get_rollID_dropdown() {
            this.roll_ID_dropdownItems = [];
            var data = {};
            this.loading = true;
            var promise = apis.roleIDlist(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].user_role_name,
                            value: response.data.data[x].user_role_id,
                        });
                    }
                    this.roll_ID_dropdownItem = { name: "", value: "" };
                    this.roll_ID_dropdownItems = temp_data;
                }
            });
        },
        getStateData() {
            this.state_dropdownItems = [];
            var data = {};
            this.loading = true;
            var promise = apis.StateList(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].State_name,
                            value: response.data.data[x].State_id,
                        });
                    }
                    this.state_dropdownItem = null;
                    this.state_dropdownItems = temp_data;
                }
            });
        },
        getDistrictData() {
            this.district_dropdownItems = [];
            var state_id = "";
            if (this.state_dropdownItem) {
                var state_id = this.state_dropdownItem.value;
            }
            var data = {
                state_id: state_id
            };
            this.loading = true;
            var promise = apis.DistrictList(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name,
                            value: response.data.data[x].DistrictID,
                        });
                    }
                    this.district_dropdownItem = null;
                    this.district_dropdownItems = temp_data;
                }
            });
        },
        getMuncipalCorporationData() {
            this.mcorporation_dropdownItems = [];
            var district_id = "";
            if (this.district_dropdownItem) {
                var district_id = this.district_dropdownItem.value;
            }
            var data = {
                district_id: district_id
            };
            this.loading = true;

            var promise = apis.MuncipalCorporationList(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].MunicipalCorporation,
                            value: response.data.data[x].id,
                        });
                    }
                    this.mcorporation_dropdownItem = null;
                    this.mcorporation_dropdownItems = temp_data;
                }
            });
        },
        get_hoarding_dropdown() {
            this.hoarding_dropdownItems = [];
            var data = {};
            this.loading = true;
            var promise = apis.HoardingDropdownList(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].HoardingName,
                            value: response.data.data[x].id,
                        });
                    }
                    this.hoarding_dropdownItem = { name: "", value: "" };
                    this.hoarding_dropdownItems = temp_data;
                    // console.log("hoarding data--", this.hoarding_dropdownItems);
                }
            });
        },

        get_user_dropdown() {
            this.user_dropdownItems = [];
            var data = {};
            this.loading = true;
            var promise = apis.UserDropdownList(data);
            promise.then((response) => {
                this.loading = false;
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].UserName,
                            value: response.data.data[x].UserID,
                        });
                    }
                    this.user_dropdownItem = { name: "", value: "" };
                    this.user_dropdownItems = temp_data;
                    // console.log("user data--", this.user_dropdownItems);
                }
            });
        },

        deletegroup() {
            if (this.product.ID) {
                var data = {
                    ID: this.product.ID,
                };
                this.isLoadingModel = true;
                var promise = apis.admindeleteusermaster(data);
                promise.then((responseapi) => {
                    this.isLoadingModel = false;
                    if (responseapi.data.status == true) {
                        this.deleteProductDialog = false;
                        this.$swal(responseapi.data.message);
                        this.get_list();
                        this.get_count();
                    } else {
                        this.$swal("error to Delete Record");
                    }
                });
            }
        },
        onHide() {
            this.product = {};
            this.state_selected = { name: "", value: "" };
            this.district_selected = { name: "", value: "" };
            this.mcorporation_selected = { name: "", value: "" };
            this.status_selected = { name: "", value: "" };
            this.rollID_selected = { name: "", value: "" };
            this.reset_upload();
            this.productDialog = false;
        },
        async search(count) {
            if (count == 2) {
                this.search_status = "";
                this.search_hoarding = "";
                this.search_user = "";
                this.search_title = "";
                this.search_application_mobile = "";
                this.state_dropdownItem = null;
                this.district_dropdownItem = null;
                this.mcorporation_dropdownItem = null;
            }

            await this.get_list();
            await this.get_count();
        },
        async adduser() {
            this.submitted = true;
            if (!this.product.NAME) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter USer name",
                    life: 3000,
                });
                return false;
            }

            const phoneRegex = /^[0-9]{10}$/;
            if (!this.product.MOBILE || (this.product.MOBILE && !phoneRegex.test(this.product.MOBILE))) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Enter valid Mobile No",
                    life: 3000,
                });
                return false;
            }

            var emailreg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
            if (this.product.EMAIL) {
                if (emailreg.test(this.product.EMAIL) == false) {
                    this.$toast.add({
                        severity: "error",
                        summary: "error",
                        detail: "Please Enter valid Email ID",
                        life: 3000,
                    });
                    return false;
                }
            }

            // if (!this.product.ADDRESS) {
            //     this.$toast.add({
            //         severity: "error",
            //         summary: "error",
            //         detail: "Please Enter Address",
            //         life: 3000,
            //     });
            //     return false;
            // }

            // if (!this.product.PINCODE) {
            //     this.$toast.add({
            //         severity: "error",
            //         summary: "error",
            //         detail: "Please Enter Pin code",
            //         life: 3000,
            //     });
            //     return false;
            // }

            if (this.status_selected == null || this.status_selected.value == '' || this.status_selected.value == undefined || this.status_selected.value == []) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select State",
                    life: 3000,
                });
                return false;
            }

            if (this.rollID_selected == null || this.rollID_selected.value == '' || this.rollID_selected.value == undefined || this.rollID_selected.value == []) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select User Type",
                    life: 3000,
                });
                return false;
            }

            if (this.state_selected == null || this.state_selected.value == '' || this.state_selected.value == undefined || this.state_selected.value == []) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select State",
                    life: 3000,
                });
                return false;
            }

            if (this.district_selected == null || this.district_selected.value == '' || this.district_selected.value == undefined || this.district_selected.value == []) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select District",
                    life: 3000,
                });
                return false;
            }

            if (this.mcorporation_selected == null || this.mcorporation_selected.value == '' || this.mcorporation_selected.value == undefined || this.mcorporation_selected.value == []) {
                this.$toast.add({
                    severity: "error",
                    summary: "error",
                    detail: "Please Select Muncipal Corporation",
                    life: 3000,
                });
                return false;
            }

            var status = '';
            if (this.status_selected) {
                status = this.status_selected.value;
            }

            var roll_id = '';
            if (this.rollID_selected) {
                roll_id = this.rollID_selected.value;
            }

            var state = '';
            if (this.state_selected) {
                state = this.state_selected.value;
            }

            var district = '';
            if (this.district_selected) {
                district = this.district_selected.value;
            }

            var muncipal_corporation = '';
            if (this.mcorporation_selected) {
                muncipal_corporation = this.mcorporation_selected.value;
            }

            var profile = "";
            if (this.Thumbnail_data.filePath!='') {
                var profile = encodeURI("https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/" +this.Thumbnail_data.filePath);
            }
            //edit
            if (this.product.ID) {
                var data = {
                    "ID": this.product.ID,
                    "NAME": this.product.NAME,
                    "MOBILE": this.product.MOBILE,
                    "EMAIL": this.product.EMAIL,
                    "PASSWORD": this.product.PASSWORD,
                    "ADDRESS": this.product.ADDRESS,
                    "PINCODE": this.product.PINCODE,
                    "status": status,
                    "state": state,
                    "district": district,
                    "roll_id": roll_id,
                    "muncipal_corporation": muncipal_corporation,
                    "updated_by": localStorage.getItem("id"),
                    "profile_photo":profile                    
                };
                // console.log(data);
                // return false;
                this.isLoadingModel = true;
                var promise = apis.admineditusermaster(data);
                promise
                    .then((response) => {
                        this.isLoadingModel = false;
                        if (response.data.status == true) {
                            this.productDialog = false;
                            this.$swal(response.data.message);
                            this.get_list();
                            this.get_count();
                        } else {
                            this.$swal(response.data.message);
                        }
                    })
                    .catch((error) => {
                        //console.log(error);
                        // alert("edited");
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data.error);
                        this.get_list();
                        this.get_count();
                    });
            }
            //add-----------------------------------------------------------------------------------------------------------------
            else {
                // alert("add");
                var data1 = {
                    // "ID": this.product.ID,
                    "NAME": this.product.NAME,
                    "MOBILE": this.product.MOBILE,
                    "EMAIL": this.product.EMAIL,
                    "PASSWORD": this.product.PASSWORD,
                    "ADDRESS": this.product.ADDRESS,
                    "PINCODE": this.product.PINCODE,
                    "status": status,
                    "state": state,
                    "district": district,
                    "roll_id": roll_id,
                    "muncipal_corporation": muncipal_corporation,
                    "created_by": localStorage.getItem("id"),
                    "profile_photo":profile
                };
                // console.log(data1);
                // return false;
                this.isLoadingModel = true;
                var promises = apis.adminaddusermaster(data1);
                promises
                    .then((response) => {
                        this.isLoadingModel = false;
                        if (response.data.status == true) {
                            this.productDialog = false;
                            this.$swal(response.data.message);
                            this.get_list();
                            this.get_count();
                        } else {
                            this.$swal(response.data.message);
                        }

                    })
                    .catch((error) => {
                        //console.log(error);
                        this.isLoadingModel = false;
                        this.productDialog = false;
                        this.$swal.fire(error.response.data.error);
                        this.get_list();
                        this.get_count();
                    });
            }

        },
        dateFormatYMD(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;

                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);

                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return year + "-" + month + "-" + date;
                    }
                }
            }
            else {
                return "";
            }
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == 'NaN-NaN-NaN') {
                    return postdate;

                }
                else {
                    let date = ("0" + inputDate.getDate()).slice(-2);

                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == 'aN') {
                        return postdate;
                    }
                    else {
                        return date + "-" + month + "-" + year;
                    }
                }
            }
            else {
                return "";
            }
        },
        //a simple date formatting function
        dateFormat(inputDate, info) { },
        handleFileUpload() {
            this.file_attachment = this.$refs.file_attachment.files[0];
            //alert(this.$refs.file_attachment.files[0].name);
        },
        async onPage(event) {
            this.lazyParams = event;
            this.page_no = event.page + 1;
            this.limit = event.rows;
            // console.log(event);
            // await this.get_count();
            if (this.totalRecords > 0) {
                this.get_list();
            }
        },
        get_count: function () {
            var status = '';
            var state = "";
            var district = "";
            var muncipal = "";
            if (this.search_status) {
                status = this.search_status.value;
            }

            if (this.state_dropdownItem) {
                state = this.state_dropdownItem.value;
            }

            if (this.district_dropdownItem) {
                district = this.district_dropdownItem.value;
            }

            if (this.mcorporation_dropdownItem) {
                muncipal = this.mcorporation_dropdownItem.value;
            }

            var data = {
                count: true,
                name: this.search_title,
                MobileNo: this.search_application_mobile,
                status: status,
                // hoarding_id: hoarding_id,
                // user_id: user_id,
                state_id: state,
                district_id: district,
                muncipal_corporation_id: muncipal,


            };
            this.loading = true;
            var promise = apis.adminuserlist(data, this.id);
            promise.then((response) => {
                this.loading = false;
                // console.log(response);
                this.totalRecords = response.data.total;
                //alert(this.totalRecords);
            });
            // console.log(data);
        },
        get_list: function () {
            var status = '';
            var state = "";
            var district = "";
            var muncipal = "";

            if (this.search_status) {
                status = this.search_status.value;
            }

            if (this.state_dropdownItem) {
                state = this.state_dropdownItem.value;
            }

            if (this.district_dropdownItem) {
                district = this.district_dropdownItem.value;
            }

            if (this.mcorporation_dropdownItem) {
                muncipal = this.mcorporation_dropdownItem.value;
            }

            var data = {
                page_no: this.page_no,
                Limit: this.limit,
                count: false,
                name: this.search_title,
                MobileNo: this.search_application_mobile,
                status: status,
                // hoarding_id: hoarding_id,
                // user_id: user_id,
                state_id: state,
                district_id: district,
                muncipal_corporation_id: muncipal,

            };
            this.loading = true;
            var promise = apis.adminuserlist(data, this.id);
            promise.then((response) => {
                this.loading = false;
                // console.log(response);
                this.products = response.data.data;
                // console.log(this.products[0]);
                if (this.columns.length == 0) {
                    if (this.products.length > 0) {
                        this.columns = Object.keys(this.products[0]);
                    }
                }
            });
            // console.log(data);
        },
        formatCurrency(value) {
            if (value)
                return value.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                });
            return;
        },
        openNew() {
            this.product = {};
            this.submitted = false;
            this.productDialog = true;
        },
        hideDialog() {
            this.productDialog = false;
            this.submitted = false;
        },
        saveProduct() {
            this.submitted = true;
            if (this.product.id) {
                //
            } else {
                //
            }
            this.productDialog = false;
            this.product = {};
        },
        editProduct(product) {
            this.product = { ...product };
            this.status_selected.value = this.product.STATUS;
            this.status_selected.name = this.product.STATUS;

            this.state_selected.value = this.product.StateID;
            this.state_selected.name = this.product.State_name;

            this.district_selected.value = this.product.DistrictID;
            this.district_selected.name = this.product.district_name;

            this.mcorporation_selected.value = this.product.Municipal_CorporationID;
            this.mcorporation_selected.name = this.product.MunicipalCorporation;

            this.rollID_selected.value = this.product.user_role_id;
            this.rollID_selected.name = this.product.user_role_name;
            this.imgDataUrl = this.product.PROFILE_PHOTO;

            // console.log("edit data:-", this.product);
            this.productDialog = true;
        },
        async viewProduct(product) {
            this.file_attachment = "";
            this.product = { ...product };
        },
        confirmDeleteProduct(product) {
            this.product = product;
            this.deleteProductDialog = true;
        },
        exportCSV() {
            this.$refs.dt.exportCSV();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
    },
    // components: {},
    components: { GoogleMap, Marker, MarkerCluster, InfoWindow, GMapMarker, Polyline, "my-upload": myUpload },
};
</script>
<style scoped lang="scss">
.label-gap {
    margin-bottom: 0.8rem;
}

.toggle-password-button {
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 5px;
    display: flex;
    align-items: center;
    font-size: 1rem;
    padding: 0;
}

@import "../assets/demo/badges.scss";
</style>